export default "__VITE_ASSET__04yJXr6Y__"